module.exports = __webpack_public_path__ + "static/media/promotion_from_40_to_44.b2bdcdcd.webp";